import { OVERALL_BAND_COPY } from '../../data/resultCopy';
import type { OverallBandDefinition } from '../../data/schemas';
import type {
  ChannelRoleResult,
  ClusterResult,
  DetectedTension,
  DiagnosticInsight,
  ResultSummary,
} from '../../types/result';

/**
 * Setzt die Ergebniszusammenfassung deterministisch aus kontrollierten Textbausteinen zusammen
 * (Abschnitt 22). Es wird keine freie Texterzeugung verwendet.
 */
export function composeResultSummary(
  overallBand: OverallBandDefinition,
  clusters: readonly ClusterResult[],
  tensions: readonly DetectedTension[],
  weakPoints: readonly DiagnosticInsight[],
  channelRole: ChannelRoleResult,
): ResultSummary {
  const bandCopy = OVERALL_BAND_COPY[overallBand.id];

  const strongestCluster = [...clusters].sort((a, b) => b.percentage - a.percentage)[0];
  const weakestCluster = [...clusters].sort((a, b) => a.percentage - b.percentage)[0];
  const topTension = tensions[0];

  const paragraphs: string[] = [bandCopy.headline];

  if (strongestCluster && weakestCluster) {
    paragraphs.push(
      `Besonders gut passen aktuell die Voraussetzungen im Bereich „${strongestCluster.title}“. Der wichtigste Engpass liegt derzeit im Bereich „${weakestCluster.title}“.`,
    );
  }

  if (topTension) {
    paragraphs.push(topTension.summary);
  }

  paragraphs.push(`Daraus folgt: ${channelRole.summary}`);

  return {
    headline: bandCopy.headline,
    shortVerdict: overallBand.shortLabel,
    summaryText: paragraphs.join(' '),
    primaryMessage: channelRole.summary,
    mainCondition: weakPoints[0]?.summary ?? bandCopy.detail,
    mainTension: topTension?.title,
  };
}
